import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import roleAccessMap , { publicRoutes }  from "./../util/roleAccessMap";

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to, from ,savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});
// Add a navigation guard
router.beforeEach((to, from, next) => {
  // Get the role from local storage
  const userRole = localStorage.getItem('hot-user');

  // Check if the route requires a specific role
  if (to.meta.roles && !to.meta.roles.includes(userRole)) {
    return next({ path: '*' });
  }
  // Allow navigation if the role matches
  next();
});

router.beforeEach((to, from, next) => {
  const routeExists = router.getRoutes().some(r => r.path === to.path);
  if (!routeExists) {
    return next();
  }

  const authRequired = !publicRoutes.includes(to.path);
  if (!authRequired) return next();

  const role = localStorage.getItem("hot-user");
  if (!role) return next("/login");
if (["super-admin", "sub-admin"].includes(role)) {
    return next();
  }
  const allowedRoutes = roleAccessMap[role] || [];
  if (!allowedRoutes.includes(to.path)) {
      Vue.$toast.error('Not authorized', {
    timeout: 5000,
  });
  return next("/not_authorized");
  }
  return next();
});
export default router;
